import React, { Fragment, useState, useEffect, useRef } from "react";
import { useLocation, Navigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Grid2';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from "@mui/material/CircularProgress";
import { getCountryName } from "../../utils/general.js";
import DeviceModelControlCapability from "./DeviceModelCapability/DeviceModelControlCapability.js";
import DeviceModelStatusCapability from "./DeviceModelCapability/DeviceModelStatusCapability.js";
import DeviceModelDiagCapability from "./DeviceModelCapability/DeviceModelDiagCapability.js";
import DeviceModelConfigCapability from "./DeviceModelCapability/DeviceModelConfigCapability.js";
import ChannelAndSwitches from "./DeviceModelCapability/ChannelAndSwitches.js";
import { addDeviceModel, updateDeviceModel, clearDeviceModelData, getDeviceModelsMetaData, clearDeviceModelsMetadata, getModelId, getDeviceByModelNumber } from "../../action/addvcModel";
import { setAlert } from "../../action/alert";
import Alert from "./../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import customConfig from "../../config.js";
import { selectMenuProps } from "../../utils/selectMenuProps";
import { addFreqToPower } from "../../action/report.js";
import FormInput from "../Common/FormInputs/MuiTextField";
import MuiDatePicker from "../Common/FormInputs/MuiDatePicker";
import AppButton from "../Common/Button/Button";
import AppTabs from "../Common/Tabs/AppTabs";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../theme/useDesignTokens";
import "./DeviceDetails.css";

function hasAtMostOneDecimal(value) {
  return /^\d+(\.\d)?$/.test(value);
}

function requiresFreqPowerRecords(category, launchYear) {
  const year = Number(launchYear);
  return category === customConfig.decviceCategoryAC && Number.isFinite(year) && year < 2027;
}

function validateFreqPowerBodies(freqPowerBodies) {
  if (freqPowerBodies.length !== 15) {
    return { valid: false, message: "Add exactly 15 records for Frequency-Power conversion" };
  }

  const freqMap = new Map();
  const rrpmMap = new Map();

  for (let i = 0; i < freqPowerBodies.length; i++) {
    const { frequency, rrpm_c } = freqPowerBodies[i];

    if (freqMap.has(frequency)) {
      return {
        valid: false,
        message: `Duplicate Frequency "${frequency}" found at index ${freqMap.get(frequency)} and ${i}`,
      };
    }
    freqMap.set(frequency, i);

    if (rrpmMap.has(rrpm_c)) {
      return {
        valid: false,
        message: `Duplicate Rrpm_c "${rrpm_c}" found at index ${rrpmMap.get(rrpm_c)} and ${i}`,
      };
    }
    rrpmMap.set(rrpm_c, i);
  }

  return { valid: true };
}


const AddNewDeviceModel = ({
    allowedCountryCodes,
    allowedDeviceCategories,
    addDeviceModel,
    updateDeviceModel,
    setAlert,
    ModelData: { getModel, updvcModel, deviceModelsMetadata, ModelData: fetchedModelData },
    clearDeviceModelData,
    getDeviceModelsMetaData,
    clearDeviceModelsMetadata,
    wrapperClass,
    addFreqToPower,
    getModelId,
    getDeviceByModelNumber,
}) => {

    const location = useLocation()
    const [editDeviceModel] = useState(location.state ? location.state.editDeviceModel : false)
    const [deviceModelData, setDeviceModelData] = useState(location.state ? location.state.deviceModelData : null)
    const modelIdFromState = location.state?.modelId;
    const modelNumberFromState = location.state?.modelNumber;
    const [freqPowerBodies, setFreqPowerBodies] = useState((location.state?.freqToPowerData?.records ?? [{ frequency: "", rrpm_c: "", power: "" }]).map(obj => ({ ...obj })));
    const initialFreqPower = useRef(JSON.parse(JSON.stringify(location.state?.freqToPowerData?.records ?? [{ frequency: "", rrpm_c: "", power: "" }])));

    const [modelID, setModelID] = useState(deviceModelData?.modelID ?? "")
    const [modelNumber, setModelNumber] = useState(deviceModelData?.modelNumber ?? "")
    const [modelName, setModelName] = useState(deviceModelData?.modelName ?? "")
    const [productCategory, setProductCategory] = useState(deviceModelData?.category ?? "")
    const [productCategoryFromMetadata, setProductCategoryFromMetadata] = useState(getProductCategoryMapping(productCategory))
    const [launchDate, setLaunchDate] = useState(deviceModelData?.launchDate ? new Date(deviceModelData.launchDate * 1000) : new Date())
    const [isActive, setIsActive] = useState(deviceModelData?.isActive ?? "true")
    const [manufacturerName, setManufacturerName] = useState(deviceModelData?.manufacturer ?? "Panasonic India Pvt Ltd")
    const [manufacturerAddress, setManufacturerAddress] = useState(deviceModelData?.manufacturerAddress ?? "GGN, India")
    const [productVersionNo, setProductVersionNo] = useState(deviceModelData?.version ?? 1)
    const [helpDocsURL, setHelpDocsURL] = useState(deviceModelData?.helpDocUrl ?? "")
    const [productManagerId, setProductManagerId] = useState(deviceModelData?.productManagerId ?? "")
    const [countries, setCountries] = useState(deviceModelData?.countries ?? [])
    const [brandName, setBrandName] = useState(
        deviceModelData?.brand ? deviceModelData.brand :
            deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.brands?.[0]?.toUpperCase() ?? "")

    const [tonnage, setTonnage] = useState(
        deviceModelData?.tonnage ? deviceModelData.tonnage :
            deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.tonnage?.[0] ?? "")

    const [addNewTonnageValue, setAddNewTonnageValue] = useState(false)

    const [capacity, setCapacity] = useState(
        deviceModelData?.capacity ? deviceModelData.capacity :
            deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.capacity?.[0] ?? "")

    const [channelAndSwitchDevices, setChannelAndSwitchDevices] = useState(deviceModelData?.devices ?? [])
    const [channelAndSwitchDeviceTypes, setChannelAndSwitchDeviceTypes] = useState([])

    const [activeTab, setActiveTab] = React.useState(0)
    const [randomValue, SetRandomValue] = useState(false)

    const [deviceCapabilitiesData, setDeviceCapabilitiesData] = useState({})
    const [isControlCapabilitiesValid, setIsControlCapabilitiesValid] = useState(false)
    const [isStatusCapabilitiesValid, setIsStatusCapabilitiesValid] = useState(false)
    const [isConfigCapabilitiesValid, setIsConfigCapabilitiesValid] = useState(false)
    const [isDiagCapabilitiesValid, setIsDiagCapabilitiesValid] = useState(false)
    const [isAddEditDeviceModelSuccessful, setIsAddEditDeviceModelSuccessful] = useState(false)
    const [shouldNavigateAfterSuccess, setShouldNavigateAfterSuccess] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const [isDeviceModelsMetadataLoading, setIsDeviceMetadataLoading] = useState(false)

    const hiddenDeviceMetadataUpload = useRef(null);
    const [isDeviceModelAddedUsingFileUpload, setIsDeviceModelAddedUsingFileUpload] = useState(false)

    // matter related fields
    const [isMatterEnabled, setIsMatterEnabled] = useState(deviceModelData?.isMatterEnabled ?? false)
    const [matterChipType, setMatterChipType] = useState(deviceModelData?.chipType ?? "")
    const [matterProductId, setMatterProductId] = useState(deviceModelData?.matterPID ?? "")
    const [matterVendorId, setMatterVendorId] = useState(deviceModelData?.vendorId ?? "")
    // adding the subcategory 
    const [modelSubCategory, setModelSubCategory] = useState("")    
    const [enrolementProfileId, setEnrolementProfileId] = useState(deviceModelData?.enrolementProfileId ?? "")
    const [variant, setVariant] = useState(deviceModelData?.variant ?? "")
    const [acLaunchYear, setAcLaunchYear] = useState(
        deviceModelData?.launchYear != null ? String(deviceModelData.launchYear) : "")
    const [scalingFactor, setScalingFactor] = useState(
        deviceModelData?.scalingFactor != null ? deviceModelData.scalingFactor : "")
    const [energyComputationMode, setEnergyComputationMode] = useState(
        deviceModelData?.energyComputationMode ?? "")
    const [starRating, setStarRating] = useState(
        deviceModelData?.starRating != null ? String(deviceModelData.starRating) : "")
    const [starRatingRequired, setStarRatingRequired] = useState(
        Boolean(editDeviceModel && deviceModelData?.starRating != null))
    const hasRequestedFullModel = useRef(false);

    const [areAllCustomJsonValid, setAreAllCustomJsonValid] = useState({
        control: true, status: true, config: true, diag: true
    })
    const validationMessages = {
        control: "A Custom JSON in Control Capabilities is invalid. Please fix it and try again.",
        status: "A Custom JSON in Status Capabilities is invalid. Please fix it and try again.",
        config: "A Custom JSON in Config Capabilities is invalid. Please fix it and try again.",
        diag: "A Custom JSON in Diag Capabilities is invalid. Please fix it and try again."
    };

    function addFreqPowerRow () {
        setFreqPowerBodies([...freqPowerBodies, { frequency: "", rrpm_c: "", power: "" } ]);
    };

    function removeFreqPowerRow (index) {
        setFreqPowerBodies(freqPowerBodies.filter((_, i) => i !== index));
    };

    const theme = useTheme();
    const { colors } = useDesignTokens();
    const primaryColor = colors?.primary?.main || theme.palette.primary.main;
    const desktopFieldSx = {
        width: "100%",
    };
    const focusOutlineSx = {
        ...desktopFieldSx,
        "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.42) !important",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.87)",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: `${primaryColor} !important`,
            borderWidth: "1px",
        },
        "& .MuiOutlinedInput-root.Mui-expanded .MuiOutlinedInput-notchedOutline, & .Mui-expanded .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.42) !important",
            borderWidth: "1px",
        },
        "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.Mui-expanded": {
            color: `${primaryColor} !important`,
        },
    };
    const selectInputSx = {
      ...desktopFieldSx,
      width: "100%",
      ...focusOutlineSx,
    };
    const isAcCategory = productCategory === customConfig.decviceCategoryAC;

    useEffect(() => {
        clearDeviceModelsMetadata();
    }, []);

    useEffect(() => {
        // Prevent stale add/update state from forcing immediate redirect
        clearDeviceModelData();
    }, [clearDeviceModelData]);

    useEffect(() => {
        if (deviceModelData) {
            setModelID(deviceModelData.modelId)
            setModelNumber(deviceModelData.modelNumber)
            setModelName(deviceModelData.modelName)
            setProductCategory(getProductCategoryMapping(deviceModelData.category))
            setLaunchDate(deviceModelData?.launchDate ? new Date(deviceModelData.launchDate * 1000) : new Date())
            setIsActive(deviceModelData.isActive)
            setManufacturerName(deviceModelData.manufacturer)
            setProductVersionNo(deviceModelData.version)
            setHelpDocsURL(deviceModelData.helpDocUrl)
            setProductManagerId(deviceModelData.productManagerId)
            setCountries(deviceModelData.countries ?? [])
            setBrandName(deviceModelData.brand)
            setTonnage(deviceModelData.tonnage)
            setCapacity(deviceModelData.capacity)
            setChannelAndSwitchDevices(deviceModelData?.devices ?? [])
            setModelSubCategory(deviceModelData?.subCategory ?? "")
            setIsMatterEnabled(deviceModelData?.isMatterEnabled ?? false)
            setMatterChipType(deviceModelData?.chipType ?? "")
            setMatterProductId(deviceModelData?.matterPID ?? "")
            setMatterVendorId(deviceModelData?.vendorId ?? "")
            setEnrolementProfileId(deviceModelData?.enrolementProfileId ?? "")
            setVariant(deviceModelData?.variant ?? "")
            setAcLaunchYear(deviceModelData?.launchYear != null ? String(deviceModelData.launchYear) : "")
            setScalingFactor(deviceModelData?.scalingFactor != null ? deviceModelData.scalingFactor : "")
            setEnergyComputationMode(deviceModelData?.energyComputationMode ?? "")
            setStarRating(deviceModelData?.starRating != null ? String(deviceModelData.starRating) : "")
            if (editDeviceModel && deviceModelData?.starRating != null) {
                setStarRatingRequired(true)
            }
        }
    }, [deviceModelData, editDeviceModel])

    useEffect(() => {
        if (!editDeviceModel) {
            return;
        }
        if (deviceModelData && Object.keys(deviceModelData).length > 0) {
            return;
        }
        if (modelIdFromState) {
            getModelId(modelIdFromState);
            return;
        }
        if (modelNumberFromState) {
            getDeviceByModelNumber(modelNumberFromState);
        }
    }, [editDeviceModel, deviceModelData, modelIdFromState, modelNumberFromState, getModelId, getDeviceByModelNumber]);

    useEffect(() => {
        if (!editDeviceModel) {
            return;
        }
        if (!deviceModelData) {
            return;
        }
        const modelIdToFetch = deviceModelData?.modelId || modelID;
        const needsCapabilities = !deviceModelData?.controlCapabilities || !deviceModelData?.statusCapabilitiesV2;
        if (modelIdToFetch && needsCapabilities && !hasRequestedFullModel.current) {
            hasRequestedFullModel.current = true;
            getModelId(modelIdToFetch);
        }
    }, [editDeviceModel, deviceModelData, modelID, getModelId]);

    useEffect(() => {
        if (!editDeviceModel) {
            return;
        }
        if (!fetchedModelData || Object.keys(fetchedModelData).length === 0) {
            return;
        }
        setDeviceModelData(fetchedModelData);
    }, [editDeviceModel, fetchedModelData]);

    useEffect(() => {
        if (productCategory && productCategory.length!==0) {
            setIsDeviceMetadataLoading(true)
            getDeviceModelsMetaData(getProductCategoryMapping(productCategory))
            setProductCategoryFromMetadata(getProductCategoryMapping(productCategory))
        }
    }, [productCategory, getDeviceModelsMetaData])

    const areAllCustomJsonValidCheck = (value, capabilityName) =>{
        setAreAllCustomJsonValid((prev) => ({
            ...prev, [capabilityName]: value
        }))
    }

    const getInvalidMessages = (validationState) => {
        return Object.entries(validationState)
            .filter(([_, isValid]) => !isValid)
            .map(([key]) => validationMessages[key] || `${key} is invalid.`);
    };

    const hasDuplicateInArray = (arr = []) => {
        const capabilities = arr.map(item => item?.capability).filter(Boolean);

        return new Set(capabilities).size !== capabilities.length;
    };

    useEffect(() => {
        if (!(isControlCapabilitiesValid && isStatusCapabilitiesValid && isConfigCapabilitiesValid && (!isAcCategory || isDiagCapabilitiesValid))) {
            return; //return in case of invalid capabilities data
        }

        const isValid = () => {
            const hasControlDuplicate = hasDuplicateInArray(deviceCapabilitiesData?.controlCapabilities);
            const hasStatusDuplicate = hasDuplicateInArray(deviceCapabilitiesData?.statusCapabilitiesV2);
            const hasDiagDuplicate = hasDuplicateInArray(deviceCapabilitiesData?.diagCapabilities);
            const hasConfigDuplicate = hasDuplicateInArray(deviceCapabilitiesData?.configCapabilities);

            if (!modelID || modelID === "") {
              setAlert("Invalid Model ID", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!modelNumber || modelNumber === "") {
              setAlert("Invalid Model Number", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!modelName || modelName === "") {
              setAlert("Invalid Model Name", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!manufacturerName || manufacturerName.length === 0) {
              setAlert("Invalid Manufacturer Name", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!manufacturerAddress || manufacturerAddress.length === 0) {
              setAlert("Invalid Manufacturer Address", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!brandName || brandName.length === 0) {
              setAlert("Invalid Brand Name", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!productManagerId || productManagerId.length === 0) {
              setAlert("Invalid Product Manager", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!countries || countries.length === 0) {
              setAlert("Please Select Country", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!productVersionNo || isNaN(productVersionNo)) {
              setAlert("Invalid Version Number", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (
              deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.tonnage &&
              (!tonnage || tonnage.length === 0 || isNaN(tonnage) || (parseFloat(tonnage) < 0))
            ) {
              setAlert("Invalid Tonnage Value", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (
              deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.capacity &&
              (!capacity || capacity.length === 0)
            ) {
              setAlert("Invalid Capacity Value", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (!matterChipType || matterChipType === "") {
              setAlert("Invalid Chip Type", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (isMatterEnabled === true && (!matterProductId || matterProductId === "")) {
              setAlert("Invalid Product ID", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (
              isMatterEnabled === true &&
              (!matterVendorId || matterVendorId === "" || isNaN(parseInt(matterVendorId)))
            ) {
              setAlert("Invalid Vendor ID", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (productCategory === customConfig.decviceCategoryAC) {
              if (!variant) {
                setAlert("Invalid Variant", "danger");
                window.scrollTo(0, 0);
                return false;
              }
              if (!acLaunchYear) {
                setAlert("Invalid Launch Year", "danger");
                window.scrollTo(0, 0);
                return false;
              }
              const parsedScalingFactor = Number(scalingFactor);
              if (
                scalingFactor === "" ||
                scalingFactor === null ||
                scalingFactor === undefined ||
                Number.isNaN(parsedScalingFactor) ||
                parsedScalingFactor < 0 ||
                parsedScalingFactor >= customConfig.acScalingFactorMax
              ) {
                setAlert("Invalid Scaling Factor. Value must be less than 5", "danger");
                window.scrollTo(0, 0);
                return false;
              }
              if (!energyComputationMode) {
                setAlert("Invalid Energy Computation Mode", "danger");
                window.scrollTo(0, 0);
                return false;
              }
            }
            const trimmedStarRating = String(starRating ?? "").trim();
            if (starRatingRequired && !trimmedStarRating) {
              setAlert("Star Rating cannot be removed once added.", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (trimmedStarRating && !hasAtMostOneDecimal(trimmedStarRating)) {
              setAlert("Star Rating can have only one decimal place.", "danger");
              window.scrollTo(0, 0);
              return false;
            }
            if (
              requiresFreqPowerRecords(productCategory, acLaunchYear) &&
              deviceCapabilitiesData?.statusCapabilitiesV2?.some((cap) => cap.capability === "PowerConsumption")
            ) {
              const result = validateFreqPowerBodies(freqPowerBodies);
              if (!result.valid) {
                setAlert(result.message, "danger");
                window.scrollTo(0, 0);
                return false;
              }
            }

            const messages = getInvalidMessages(areAllCustomJsonValid);
            if (messages.length > 0) {
                setAlert(messages.join("\n"), "danger");
                window.scrollTo(0, 0);
                return false;
            }

            if (hasControlDuplicate) {
                setAlert("A duplicate capability exists in Control Capabilities. Please remove the duplicate and try again.", "danger");
                window.scrollTo(0, 0);
                return false;
            }

            if (hasStatusDuplicate) {
                setAlert("A duplicate capability exists in Status Capabilities. Please remove the duplicate and try again.", "danger");
                window.scrollTo(0, 0);
                return false;
            }

            if (hasConfigDuplicate) {
                setAlert("A duplicate capability exists in Config Capabilities. Please remove the duplicate and try again.", "danger");
                window.scrollTo(0, 0);
                return false;
            }

            if (hasDiagDuplicate) {
                setAlert("A duplicate capability exists in Diag Capabilities. Please remove the duplicate and try again.", "danger");
                window.scrollTo(0, 0);
                return false;
            }

            return true;
        };
        
        const handleDeviceModel = async () => {
            if (!isValid()) return;
            let deviceModelData = {
                "modelId": modelID,
                "modelNumber": modelNumber,
                "modelName": modelName,
                "category": productCategory,
                "launchDate": parseInt(launchDate.getTime() / 1000),
                "isActive": isActive,
                "manufacturer": manufacturerName,
                "manufacturerAddress": manufacturerAddress,
                "version": parseFloat(productVersionNo),
                "helpDocUrl": !helpDocsURL || helpDocsURL.length===0 ? "http url" : helpDocsURL,
                "productManagerId": productManagerId,
                "countries": countries,
                "brand": brandName,
                ...deviceCapabilitiesData
            }

            if (deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.tonnage) {
                deviceModelData['tonnage'] = tonnage
            }

            if (deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.capacity) {
                deviceModelData['capacity'] = capacity
            }

            if (productCategoryFromMetadata===customConfig.deviceCategorySWITCHES) {
                deviceModelData['devices'] = channelAndSwitchDevices
            }

            // add matter related fields
            deviceModelData["isMatterEnabled"] = isMatterEnabled
            deviceModelData["chipType"] = matterChipType

            if (isMatterEnabled) {
                // add these fields only when device is matter enabled
                deviceModelData["matterPID"] = matterProductId
                deviceModelData["vendorId"] = parseInt(matterVendorId)
            }

            // add the subcategory
            if(modelSubCategory!==""){
                deviceModelData["subCategory"] = modelSubCategory
            }

            if (productCategoryFromMetadata === customConfig.decviceCategoryAC && enrolementProfileId?.trim()) {
                deviceModelData["enrolementProfileId"] = enrolementProfileId.trim()
            }

            if (productCategory === customConfig.decviceCategoryAC) {
                deviceModelData["variant"] = variant
                deviceModelData["launchYear"] = String(acLaunchYear)
                deviceModelData["scalingFactor"] = Number(scalingFactor)
                deviceModelData["energyComputationMode"] = energyComputationMode
            } else {
                delete deviceModelData["diagCapabilities"]
            }

            const trimmedStarRating = String(starRating ?? "").trim();
            if (trimmedStarRating) {
                deviceModelData["starRating"] = Number(trimmedStarRating);
            }

            try{
                if (editDeviceModel) {
                // delete the launch date form payload
                    delete deviceModelData["launchDate"]
                    await updateDeviceModel(modelID, deviceModelData)
                    if (
                        requiresFreqPowerRecords(productCategory, acLaunchYear) &&
                        deviceCapabilitiesData?.statusCapabilitiesV2?.some(cap => cap.capability === "PowerConsumption") &&
                        haveFreqPowerBodiesChanged()
                    ) {
                        setTimeout(() => {
                            addFreqToPower({
                                searchBy: "modelId",
                                text: deviceModelData.modelId,
                                body: freqPowerBodies
                            });
                        }, 4000);
                    }
                }
                else {
                    await addDeviceModel(deviceModelData)
                    if (requiresFreqPowerRecords(productCategory, acLaunchYear) && deviceCapabilitiesData?.statusCapabilitiesV2?.some(cap => cap.capability === "PowerConsumption")) {
                            setTimeout(()=>{
                                addFreqToPower({
                                searchBy: "modelId",
                                text: deviceModelData.modelId,
                                body: freqPowerBodies
                            })
                            }, 4000);
                        }    
                    
                }
            }
            catch(error){
                console.error("Device model operation failed:", error);
            }
        }
        
        handleDeviceModel();
    }, [isControlCapabilitiesValid, isStatusCapabilitiesValid, isConfigCapabilitiesValid, isDiagCapabilitiesValid]);

    useEffect(() => {
        if (deviceModelsMetadata && Object.keys(deviceModelsMetadata).length!==0) {
            setIsDeviceMetadataLoading(false)
        }

    }, [deviceModelsMetadata])

    /**
     * Added Array.isArray(getModel) check because an array is sometimes returned
     * instead of the expected object, which was blocking device model editing.
     */
    useEffect(() => {
        if (!getModel || Object.keys(getModel).length===0 || Array.isArray(getModel)) {
            return;
        }

        clearDeviceModelData()
        setIsAddEditDeviceModelSuccessful(true)
        setIsSubmitting(false)
    }, [getModel, clearDeviceModelData, isSubmitting])

    useEffect(() => {
        if (!isSubmitting) {
            return;
        }
        if (!updvcModel || Object.keys(updvcModel).length===0) {
            return;
        }

        clearDeviceModelData()
        setIsAddEditDeviceModelSuccessful(true)
        setIsSubmitting(false)
    }, [updvcModel, clearDeviceModelData, isSubmitting])

    useEffect(() => {
        if (!isAddEditDeviceModelSuccessful) {
            setShouldNavigateAfterSuccess(false);
            return;
        }

        // Keep user on this page briefly so success snackbar is visible.
        const navigationDelayMs = 1200;
        const timerId = setTimeout(() => {
            setShouldNavigateAfterSuccess(true);
        }, navigationDelayMs);

        return () => clearTimeout(timerId);
    }, [isAddEditDeviceModelSuccessful]);

    function haveFreqPowerBodiesChanged() {
        return JSON.stringify(initialFreqPower.current) !== JSON.stringify(freqPowerBodies);
    }

    function getProductCategoryMapping(productCategoryName) {
        if (productCategoryName===customConfig.decviceCategoryAC ||
            productCategoryName===customConfig.deviceCategoryCAC ||
            productCategoryName===customConfig.deviceCategoryIAC) {

            return customConfig.decviceCategoryAC
        }
        else if (productCategoryName===customConfig.decviceCategoryFANCONTROLLER ||
            productCategoryName===customConfig.decviceCategoryANCHORFAN) {

            return customConfig.decviceCategoryFANCONTROLLER
        }
        else if (productCategoryName===customConfig.deviceCategorySWITCHES ||
            productCategoryName===customConfig.deviceCategoryROMASWITCHES) {

            return customConfig.deviceCategorySWITCHES
        }

        return productCategoryName
    }

    function handleAddChannelsAndSwitches(devices) {
        setChannelAndSwitchDevices(devices)

        let updatedDeviceTypes = {}
        devices.map((element, index) => {
            if (element.type && element.type.length!==0) {
                updatedDeviceTypes[element.type] = ""
            }
        })

        setChannelAndSwitchDeviceTypes(Object.keys(updatedDeviceTypes))
    }

    function handleAddDeviceControlCapabilties(controlCapabilities) {
        if (!(controlCapabilities instanceof Array) && (controlCapabilities.hasOwnProperty('error'))) {
            setAlert(controlCapabilities['error'], "danger")
            setIsControlCapabilitiesValid(false)
            window.scrollTo(0, 0)
        }
        else {
            setDeviceCapabilitiesData((prevState) => {
                return {
                    ...prevState,
                    'controlCapabilities': controlCapabilities
                }
            })
            setIsControlCapabilitiesValid(true)
        }
    }

    function handleAddDeviceStatusCapabilities(statusCapabilities) {
        if (!(statusCapabilities instanceof Array) && (statusCapabilities.hasOwnProperty('error'))) {
            setAlert(statusCapabilities['error'], "danger")
            setIsStatusCapabilitiesValid(false)
            window.scrollTo(0, 0)
        }
        else {
            setDeviceCapabilitiesData((prevState) => {
                return {
                    ...prevState,
                    'statusCapabilitiesV2': statusCapabilities
                }
            })
            setIsStatusCapabilitiesValid(true)
        }
    }

    function handleAddDeviceConfigCapabilities(configCapabilities) {
        if (!(configCapabilities instanceof Array) && (configCapabilities.hasOwnProperty('error'))) {
            setAlert(configCapabilities['error'], "danger")
            setIsConfigCapabilitiesValid(false)
            window.scrollTo(0, 0)
        }
        else {
            setDeviceCapabilitiesData((prevState) => {
                return {
                    ...prevState,
                    'configCapabilities': configCapabilities
                }
            })
            setIsConfigCapabilitiesValid(true)
        }
    }

    function handleAddDeviceDiagCapabilities(diagCapabilities) {
        if (!(diagCapabilities instanceof Array) && (diagCapabilities.hasOwnProperty('error'))) {
            setAlert(diagCapabilities['error'], "danger")
            setIsDiagCapabilitiesValid(false)
            window.scrollTo(0, 0)
        }
        else {
            setDeviceCapabilitiesData((prevState) => {
                return {
                    ...prevState,
                    'diagCapabilities': diagCapabilities
                }
            })
            setIsDiagCapabilitiesValid(true)
        }
    }

    function onChangeDeviceMetadataFileUpload(event) {
        const file = event.target.files[0]
        const reader = new FileReader();
        reader.addEventListener('load', (readEvent) => {
            try {
                const parsedData = JSON.parse(readEvent.target.result)
                if (parsedData && parsedData instanceof Array) {
                    setAlert("Invalid File Uploaded. Upload Only One Device Model at a Time", "danger")
                    return
                }
                   if (parsedData.category) {
                const normalizedCategory = customConfig.allowedDeviceModelCategories.find(cat => 
                    getProductCategoryMapping(cat) === getProductCategoryMapping(parsedData.category)
                ) || parsedData.category;
                
                parsedData.category = normalizedCategory;
            }
                setDeviceModelData(parsedData)
                setIsDeviceModelAddedUsingFileUpload(true)
                
            } catch (error) {
                setAlert("Invalid File Uploaded", "danger")
            }
        });
        reader.readAsText(file);
    }
    
    return (
        <Fragment>
            <ResponsiveContentWrapper className={wrapperClass || ""}>
                <Alert />
                {shouldNavigateAfterSuccess ? <Navigate to='/deviceDetail' /> : ""}
                <Box
                    className="add-new-device-model-wrap"
                    sx={{
                        width: "100%",
                        minWidth: 0,
                        overflowX: "hidden",
                        padding: { xs: 1.5, sm: 1.5 },
                        /* MUI breakpoints: xs < 600px, sm ≥ 600px */
                        "& .MuiGrid2-root": { minWidth: 0, maxWidth: { xs: "100%", sm: "none" } },
                        "& .MuiCard-root": { minWidth: 0, overflow: "visible" },
                        "& .MuiCardContent-root": { px: { xs: 2, sm: 2 }, py: { xs: 1.5, sm: 2 }, minWidth: 0, overflow: "visible" },
                        "& .MuiGrid2-container, & .MuiGrid2-root": { minWidth: 0 },
                        "& .range-value-unit-row > .MuiBox-root": { flex: { xs: "1 1 100% !important", sm: "0 1 calc(50% - 4px) !important" }, minWidth: { xs: "0 !important", sm: 80 } },
                        "& .MuiTabs-root": { overflowX: { xs: "auto", sm: "visible" }, WebkitOverflowScrolling: { xs: "touch" } },
                        "& .MuiTab-root": { minWidth: { xs: "auto", sm: 90 }, px: { xs: 1.5, sm: 2 }, fontSize: { xs: "0.75rem", sm: "0.875rem" } },
                    }}
                >
                    <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            <FormInput
                                type="select"
                                label="Select Category"
                                name="productCategory"
                                value={productCategory || ""}
                                onChange={(e) => setProductCategory(e.target.value)}
                                options={[...customConfig.allowedDeviceModelCategories]
                                    .sort((a, b) => a.localeCompare(b))
                                    .map((c) => ({ value: c, label: c }))}
                                disabled={editDeviceModel || (productCategory && productCategory.length !== 0)}
                                sx={selectInputSx}
                                MenuProps={selectMenuProps}
                            />
                        </Grid2>
                        {productCategoryFromMetadata && productCategoryFromMetadata.length!==0 && !isDeviceModelsMetadataLoading &&
                            deviceModelsMetadata["categories"]?.[productCategoryFromMetadata]?.["subCategory"] ? (
                            <Grid2 size={{ xs: 12, md: 4 }}>
                                <FormInput
                                    type="select"
                                    label="Select Sub Category"
                                    name="modelSubCategory"
                                    value={modelSubCategory}
                                    onChange={(e) => setModelSubCategory(e.target.value)}
                                    options={(deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.subCategory ?? []).map((s) => ({ value: s.toUpperCase(), label: s.toUpperCase() }))}
                                    sx={selectInputSx}
                                    MenuProps={selectMenuProps}
                                />
                            </Grid2>
                        ) : !editDeviceModel ? (
                            <Grid2 size={{ xs: 12, md: 4 }} sx={{ visibility: "hidden", pointerEvents: "none" }} aria-hidden />
                        ) : null}
                        {!editDeviceModel && (
                            <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <input type="file" accept="application/JSON" style={{ display: "none" }} ref={hiddenDeviceMetadataUpload} onChange={(e) => {
                                    onChangeDeviceMetadataFileUpload(e)
                                }} />
                                <AppButton
                                    variant="primary"
                                    size="medium"
                                    onClick={() => hiddenDeviceMetadataUpload.current.click()}
                                >
                                    Upload Device Model
                                </AppButton>
                            </Grid2>
                        )}
                    </Grid2>
                    {
                        isDeviceModelsMetadataLoading &&
                        <div
                            style={{
                                display: "grid",
                                placeItems: "center",
                                height: "100%",
                            }}
                        >
                            <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
                        </div>
                    }
                    {
                        productCategoryFromMetadata && productCategoryFromMetadata.length!==0 && !isDeviceModelsMetadataLoading &&
                        <Fragment>
                            <Box component="div" className="add-new-device-model-form-rows">
                            <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Model ID*"
                                        name="modelID"
                                        placeholder="Enter Model ID"
                                        value={modelID}
                                        onChange={(e) => setModelID(e.target.value)}
                                        disabled={editDeviceModel}
                                        required
                                        sx={focusOutlineSx}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Model Number*"
                                        name="modelNumber"
                                        placeholder="Enter Model Number"
                                        value={modelNumber}
                                        onChange={(e) => setModelNumber(e.target.value)}
                                        required
                                        sx={focusOutlineSx}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Model Name*"
                                        name="modelName"
                                        placeholder="Enter Model Name"
                                        value={modelName}
                                        onChange={(e) => setModelName(e.target.value)}
                                        required
                                        sx={focusOutlineSx}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Manufacturer Name*"
                                        name="manufacturerName"
                                        placeholder="Enter Manufacturer Name"
                                        value={manufacturerName}
                                        onChange={(e) => setManufacturerName(e.target.value)}
                                        required
                                        sx={focusOutlineSx}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Manufacturer Address*"
                                        name="manufacturerAddress"
                                        placeholder="Enter Manufacturer Address"
                                        value={manufacturerAddress}
                                        onChange={(e) => setManufacturerAddress(e.target.value)}
                                        required
                                        sx={focusOutlineSx}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        type="select"
                                        label="Brand*"
                                        name="brandName"
                                        value={brandName}
                                        onChange={(e) => setBrandName(e.target.value)}
                                        options={(deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.brands ?? []).map((b) => ({ value: b.toUpperCase(), label: b.toUpperCase() }))}
                                        required
                                        sx={selectInputSx}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Product Manager Name*"
                                        name="productManagerId"
                                        placeholder="Enter Product Manager Name"
                                        value={productManagerId}
                                        onChange={(e) => setProductManagerId(e.target.value)}
                                        required
                                        sx={focusOutlineSx}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Version"
                                        name="productVersionNo"
                                        placeholder="Enter Version Number"
                                        value={String(productVersionNo)}
                                        onChange={(e) => setProductVersionNo(e.target.value)}
                                        sx={focusOutlineSx}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label="Help Docs URL"
                                        name="helpDocsURL"
                                        placeholder="Enter Help Docs URL"
                                        value={helpDocsURL}
                                        onChange={(e) => setHelpDocsURL(e.target.value)}
                                        sx={focusOutlineSx}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <MuiDatePicker
                                        label="Launch Date"
                                        value={launchDate}
                                        minDate={new Date()}
                                        maxDate={new Date(new Date().setDate(new Date().getDate() + 100))}
                                        onChange={(date) => setLaunchDate(date)}
                                        disabled={editDeviceModel}
                                        sx={desktopFieldSx}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        type="select"
                                        label="Is Active"
                                        name="isActive"
                                        value={isActive}
                                        onChange={(e) => setIsActive(e.target.value)}
                                        options={[{ value: "true", label: "True" }, { value: "false", label: "False" }]}
                                        sx={selectInputSx}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        type="select"
                                        label="Country*"
                                        name="countries"
                                        multiple
                                        value={Array.isArray(countries) ? countries : []}
                                        onChange={(e) => setCountries(e.target.value)}
                                        options={allowedCountryCodes
                                            .sort()
                                            .map((countryName) => ({
                                                value: countryName.toUpperCase(),
                                                label: getCountryName(countryName.toUpperCase()),
                                            }))}
                                        renderValue={(selected) =>
                                            selected.map((countryCode) => getCountryName(countryCode)).join(", ")
                                        }
                                        renderOption={(option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                <Checkbox checked={(countries ?? []).indexOf(option.value) > -1} />
                                                <ListItemText primary={option.label} />
                                            </MenuItem>
                                        )}
                                        sx={selectInputSx}
                                    />
                                </Grid2>
                            </Grid2>
                            </Box>
                            <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }} className="add-new-device-tonnage-row">
                                {
                                    deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.tonnage &&
                                    <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: "flex", flexDirection: "column" }}>
                                        {
                                            addNewTonnageValue === false ?
                                            <FormInput
                                                type="select"
                                                label="Tonnage"
                                                name="tonnage"
                                                value={tonnage}
                                                onChange={(e) => setTonnage(e.target.value)}
                                                options={(deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.tonnage ?? []).map((t) => ({ value: t, label: t }))}
                                                sx={selectInputSx}
                                            /> :
                                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                <FormInput
                                                    label="Tonnage"
                                                    name="tonnage"
                                                    placeholder="Enter New Tonnage Value"
                                                    value={tonnage}
                                                    onChange={(e) => setTonnage(e.target.value)}
                                                    sx={focusOutlineSx}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Box>
                                        }
                                    </Grid2>
                                }
                                {
                                    productCategoryFromMetadata === customConfig.decviceCategoryAC &&
                                    <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: "flex", flexDirection: "column" }}>
                                        <FormInput
                                            label="Enrolment Profile ID"
                                            name="enrolementProfileId"
                                            placeholder="Enter Enrolment Profile ID"
                                            value={enrolementProfileId}
                                            onChange={(e) => setEnrolementProfileId(e.target.value)}
                                            sx={focusOutlineSx}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid2>
                                }
                                {
                                    productCategoryFromMetadata === customConfig.decviceCategoryAC &&
                                    <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: "flex", flexDirection: "column" }}>
                                        <FormInput
                                            label={starRatingRequired ? "Star Rating*" : "Star Rating"}
                                            name="starRating"
                                            placeholder="e.g. 4.5"
                                            value={String(starRating)}
                                            type="text"
                                            onChange={(e) => setStarRating(e.target.value)}
                                            required={starRatingRequired}
                                            sx={focusOutlineSx}
                                            InputLabelProps={{ shrink: true }}
                                            slotProps={{ htmlInput: { inputMode: "decimal" } }}
                                            onKeyDown={(e) => {
                                                ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                                            }}
                                        />
                                    </Grid2>
                                }
                                {
                                    deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.capacity &&
                                    <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: "flex", flexDirection: "column" }}>
                                        <FormInput
                                            type="select"
                                            label="Capacity"
                                            name="capacity"
                                            value={capacity}
                                            onChange={(e) => setCapacity(e.target.value)}
                                            options={(deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.capacity ?? []).map((c) => ({ value: c, label: c }))}
                                            sx={selectInputSx}
                                        />
                                    </Grid2>
                                }
                            </Grid2>
                            {deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.tonnage && (
                                <Grid2 container spacing={2} sx={{ mb: 3, mt: 2 }}>
                                    <Grid2 size={{ xs: 12, md: 4 }}>
                                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                            <AppButton
                                                variant="primary"
                                                size="small"
                                                onClick={() => {
                                                    setTonnage("");
                                                    setAddNewTonnageValue(true);
                                                }}
                                            >
                                                Add New Tonnage Value
                                            </AppButton>
                                            {addNewTonnageValue && (
                                                <AppButton
                                                    variant="ghost"
                                                    size="small"
                                                    onClick={() => {
                                                        setTonnage(deviceModelData ? deviceModelData?.tonnage : deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.tonnage?.[0] ?? "")
                                                        setAddNewTonnageValue(false)
                                                    }}
                                                >
                                                    Cancel
                                                </AppButton>
                                            )}
                                        </Box>
                                    </Grid2>
                                </Grid2>
                            )}
                            {productCategory === customConfig.decviceCategoryAC && (
                                <>
                                    <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                type="select"
                                                label="Variant*"
                                                name="variant"
                                                value={variant}
                                                onChange={(e) => setVariant(e.target.value)}
                                                options={(customConfig.acDeviceModelVariants ?? []).map((item) => ({
                                                    value: item,
                                                    label: item,
                                                }))}
                                                required
                                                sx={selectInputSx}
                                                MenuProps={selectMenuProps}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                type="select"
                                                label="Launch Year*"
                                                name="acLaunchYear"
                                                value={acLaunchYear}
                                                onChange={(e) => setAcLaunchYear(e.target.value)}
                                                options={(customConfig.acDeviceModelLaunchYears ?? []).map((year) => ({
                                                    value: year,
                                                    label: year,
                                                }))}
                                                required
                                                sx={selectInputSx}
                                                MenuProps={selectMenuProps}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                label="Scaling Factor*"
                                                name="scalingFactor"
                                                placeholder="Enter value less than 5"
                                                value={String(scalingFactor)}
                                                type="number"
                                                onChange={(e) => setScalingFactor(e.target.value)}
                                                required
                                                sx={focusOutlineSx}
                                                InputLabelProps={{ shrink: true }}
                                                onKeyDown={(e) => {
                                                    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                type="select"
                                                label="Energy Computation Mode*"
                                                name="energyComputationMode"
                                                value={energyComputationMode}
                                                onChange={(e) => setEnergyComputationMode(e.target.value)}
                                                options={(customConfig.acEnergyComputationModes ?? []).map((mode) => ({
                                                    value: mode,
                                                    label: mode,
                                                }))}
                                                required
                                                sx={selectInputSx}
                                                MenuProps={selectMenuProps}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                type="select"
                                                label="Is Matter Enabled"
                                                name="isMatterEnabled"
                                                value={String(isMatterEnabled)}
                                                onChange={(e) => setIsMatterEnabled(e.target.value === "true")}
                                                options={[{ value: "true", label: "True" }, { value: "false", label: "False" }]}
                                                sx={selectInputSx}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                type="select"
                                                label="Chip Type"
                                                name="matterChipType"
                                                value={matterChipType}
                                                onChange={(e) => setMatterChipType(e.target.value)}
                                                options={
                                                    productCategory === customConfig.deviceCategoryLED
                                                        ? (customConfig.chipTypesByCategory?.LED ?? []).map((el) => ({ value: el, label: el }))
                                                        : (customConfig.matterChipType ?? []).map((cv) => ({ value: cv, label: cv }))
                                                }
                                                sx={selectInputSx}
                                            />
                                        </Grid2>
                                    </Grid2>
                                </>
                            )}
                            {productCategoryFromMetadata===customConfig.deviceCategorySWITCHES && (
                                <Grid2 container spacing={2} sx={{ mb: 3 }}>
                                    <Grid2 size={12}>
                                        <ChannelAndSwitches
                                            channelAndSwitchDevices={channelAndSwitchDevices}
                                            deviceTypes={deviceModelsMetadata?.categories?.[productCategoryFromMetadata]?.deviceTypes ?? []}
                                            addChannelAndSwitches={handleAddChannelsAndSwitches}
                                        />
                                    </Grid2>
                                </Grid2>
                            )}
                            {productCategory !== customConfig.decviceCategoryAC && (
                            <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        label={starRatingRequired ? "Star Rating*" : "Star Rating"}
                                        name="starRating"
                                        placeholder="e.g. 4.5"
                                        value={String(starRating)}
                                        type="text"
                                        onChange={(e) => setStarRating(e.target.value)}
                                        required={starRatingRequired}
                                        sx={focusOutlineSx}
                                        InputLabelProps={{ shrink: true }}
                                        slotProps={{ htmlInput: { inputMode: "decimal" } }}
                                        onKeyDown={(e) => {
                                            ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                                        }}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        type="select"
                                        label="Is Matter Enabled"
                                        name="isMatterEnabled"
                                        value={String(isMatterEnabled)}
                                        onChange={(e) => setIsMatterEnabled(e.target.value === "true")}
                                        options={[{ value: "true", label: "True" }, { value: "false", label: "False" }]}
                                        sx={selectInputSx}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <FormInput
                                        type="select"
                                        label="Chip Type"
                                        name="matterChipType"
                                        value={matterChipType}
                                        onChange={(e) => setMatterChipType(e.target.value)}
                                        options={
                                            productCategory === customConfig.deviceCategoryLED
                                                ? (customConfig.chipTypesByCategory?.LED ?? []).map((el) => ({ value: el, label: el }))
                                                : (customConfig.matterChipType ?? []).map((cv) => ({ value: cv, label: cv }))
                                        }
                                        sx={selectInputSx}
                                    />
                                </Grid2>
                            </Grid2>
                            )}
                            {
                                isMatterEnabled && (
                                    <Grid2 container spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                label="Product ID"
                                                name="matterProductId"
                                                placeholder="Enter Matter Product ID"
                                                value={matterProductId}
                                                onChange={(e) => setMatterProductId(e.target.value)}
                                                sx={focusOutlineSx}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, md: 4 }}>
                                            <FormInput
                                                label="Vendor ID"
                                                name="matterVendorId"
                                                placeholder="Enter Vendor ID"
                                                value={matterVendorId}
                                                type="number"
                                                onChange={(e) => setMatterVendorId(e.target.value)}
                                                sx={focusOutlineSx}
                                                onKeyDown={(e)=>{
                                                    ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                )
                            }
                            <Box sx={{ width: "100%", mt: 3 }}>
                                <AppTabs
                                    value={activeTab}
                                    onChange={(e, newValue) => {
                                        setActiveTab(newValue)
                                    }}
                                    tabs={[
                                        { label: "Control Capabilities" },
                                        { label: "Status Capabilities" },
                                        { label: "Config Capabilities" },
                                        ...(isAcCategory ? [{ label: "Diag Capabilities" }] : []),
                                    ]}
                                    variant="scrollable"
                                    scrollButtons={false}
                                    firstTabFlush
                                    alignLeft
                                    textTransform="uppercase"
                                    tabMinWidth={0}
                                    tabsSx={{
                                        "& .MuiTabs-flexContainer": { paddingLeft: 0, marginLeft: 0 },
                                        "& .MuiTabs-scroller": { marginLeft: 0 },
                                        "& .MuiTabs-list": { paddingLeft: 0, marginLeft: 0 },
                                    }}
                                    tabSx={{
                                        color: colors?.secondary?.main || theme.palette.text.secondary,
                                        fontWeight: 600,
                                        px: 2,
                                    }}
                                />
                                <div hidden={activeTab !== 0}>
                                    <DeviceModelControlCapability
                                        productCategory={productCategoryFromMetadata}
                                        isDeviceModelAddedUsingFileUpload={isDeviceModelAddedUsingFileUpload}
                                        editDeviceModel={editDeviceModel}
                                        deviceModelData={deviceModelData}
                                        triggerAddNewDeviceModel={randomValue}
                                        addDeviceControlCapabilties={handleAddDeviceControlCapabilties}
                                        channelAndSwitchDeviceTypes={channelAndSwitchDeviceTypes}
                                        areAllCustomJsonValidCheck={areAllCustomJsonValidCheck}
                                    />
                                </div>
                                <div hidden={activeTab !== 1}>
                                    <DeviceModelStatusCapability
                                        productCategory={productCategoryFromMetadata}
                                        isDeviceModelAddedUsingFileUpload={isDeviceModelAddedUsingFileUpload}
                                        editDeviceModel={editDeviceModel}
                                        deviceModelData={deviceModelData}
                                        triggerAddNewDeviceModel={randomValue}
                                        addDeviceStatusCapabilties={handleAddDeviceStatusCapabilities}
                                        freqPowerBodies={freqPowerBodies}
                                        setFreqPowerBodies={setFreqPowerBodies}
                                        removeFreqPowerRow={removeFreqPowerRow}
                                        addFreqPowerRow={addFreqPowerRow}
                                        initialFreqPower={initialFreqPower}
                                        launchYear={acLaunchYear}    
                                        areAllCustomJsonValidCheck={areAllCustomJsonValidCheck}      
                                    />
                                </div>
                                <div hidden={activeTab !== 2}>
                                    <DeviceModelConfigCapability
                                        productCategory={productCategoryFromMetadata}
                                        isDeviceModelAddedUsingFileUpload={isDeviceModelAddedUsingFileUpload}
                                        editDeviceModel={editDeviceModel}
                                        deviceModelData={deviceModelData}
                                        triggerAddNewDeviceModel={randomValue}
                                        addDeviceConfigCapabilities={handleAddDeviceConfigCapabilities}
                                        areAllCustomJsonValidCheck={areAllCustomJsonValidCheck}
                                    />
                                </div>
                                {isAcCategory && (
                                <div hidden={activeTab !== 3}>
                                    <DeviceModelDiagCapability
                                        productCategory={productCategoryFromMetadata}
                                        isDeviceModelAddedUsingFileUpload={isDeviceModelAddedUsingFileUpload}
                                        editDeviceModel={editDeviceModel}
                                        deviceModelData={deviceModelData}
                                        triggerAddNewDeviceModel={randomValue}
                                        addDeviceDiagCapabilities={handleAddDeviceDiagCapabilities}
                                        areAllCustomJsonValidCheck={areAllCustomJsonValidCheck}
                                    />
                                </div>
                                )}
                            </Box>
                            <Box sx={{ display: "flex", gap: 1.5, mt: 3, flexWrap: "wrap", alignItems: "center" }}>
                                <AppButton
                                    variant="primary"
                                    size="medium"
                                    onClick={() => {
                                        setIsSubmitting(true);
                                        setIsControlCapabilitiesValid(false);
                                        setIsStatusCapabilitiesValid(false);
                                        setIsConfigCapabilitiesValid(false);
                                        setIsDiagCapabilitiesValid(productCategory !== customConfig.decviceCategoryAC);
                                        SetRandomValue(Math.random());
                                    }}
                                >
                                    {editDeviceModel ? "Update Device Model" : "Add Device Model"}
                                </AppButton>
                                <Link to="/deviceDetail" style={{ textDecoration: "none", marginLeft: "10px" }}>
                                    <AppButton variant="ghost" size="medium">Cancel</AppButton>
                                </Link>
                            </Box>
                        </Fragment>
                    }

                </Box>
            </ResponsiveContentWrapper>
        </Fragment >
    )
}

const mapStateToProps = (state) => ({
    allowedCountryCodes: state.auth.allowedCountryCodes,
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    ModelData: state.getModel,
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    addDeviceModel: (deviceModelData) => dispatch(addDeviceModel(deviceModelData)),
    updateDeviceModel: (modelId, deviceModelData) => dispatch(updateDeviceModel(modelId, deviceModelData)),
    clearDeviceModelData: () => dispatch(clearDeviceModelData()),
    getDeviceModelsMetaData: (productCategory) => dispatch(getDeviceModelsMetaData(productCategory)),
    clearDeviceModelsMetadata: () => dispatch(clearDeviceModelsMetadata()),
    addFreqToPower: (params) => dispatch(addFreqToPower(params)),
    getModelId: (modelId) => dispatch(getModelId(modelId)),
    getDeviceByModelNumber: (modelNumber) => dispatch(getDeviceByModelNumber(modelNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNewDeviceModel);